import { DateTime } from 'luxon'

/**
 * 2月分の予約枠
 */
export const ReservableDays = Array.from({ length: 60 }, (_, i) =>
  DateTime.now()
    .plus({ day: i + 1 })
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
)

/**
 * 30分単位の予約枠
 */
export const ReservableTimes = Array.from({ length: 24 * 2 }, (_, i) =>
  DateTime.now()
    .set({ hour: Math.floor(i / 2), minute: (i % 2) * 30 })
    .toFormat('H:mm'),
)
